export enum SearchQASelectors {
    TAB_PANEL = 'tab-panel',
    SEARCH_INPUT_COMPONENT = 'search-component',
    SEARCH_ICON = 'search-icon',
}